import React from 'react';
import classNames from 'classnames';

import { QuoteModel } from '@/types';
import Quotee from './Quotee';
import Quote from './Quote';

type QuoteElementModel = {
  quote: QuoteModel;
  backgroundColor?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const QuoteElement = ({ quote, className, backgroundColor, ...props }: QuoteElementModel) => {
  if (!quote) {
    return null;
  }

  return (
    <div
      className={classNames(
        'quote-element flex flex-col-reverse justify-end',
        'md:[&_.quotee]:mt-5',
        quote.expert?.image
          ? 'sm:flex-row sm:[&_.quote-container]:mx-4 sm:[&_.quote-container]:my-1'
          : 'no-image sm:flex-col-reverse lg:[&_.quote-container]:m-4',
        className,
      )}
      {...props}
    >
      <Quotee expert={quote.expert} />
      <Quote quote={quote} backgroundColor={backgroundColor} className="px-2" />
    </div>
  );
};

export default QuoteElement;
